import React from 'react'
import PropTypes from 'prop-types'
import ImageFallback from 'Components/imagefallback/next_image'

const MaleDailyArticleCardFive = ({ image, title, url, category }) => {
  return (
    <>
      <a className="article-style-five" href={url}>
        <div className="article-style-five__image">
          <ImageFallback
            objectFit="cover"
            alt={title}
            src={image || process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN_SQUARE}
            fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN}
            width={360}
            height={360}
            quality={100}
          />
        </div>
        <div className="article-style-five__text">
          <div className="article-style-five__category fd-body-sm-regular">
            {category?.replace(/_/gi, ' ')}
          </div>
          <div className="article-style-five__title fd-heading-4">{title}</div>
        </div>
      </a>
      <style jsx>
        {`
          .article-style-five {
            display: grid;
            grid-template-columns: 120px 1fr;
            gap: 20px;
            text-decoration: none;
          }

          .article-style-five__image {
            height: 120px;
            width: auto;
            aspect-ratio: 1;
          }

          .article-style-five__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .article-style-five__category {
            color: var(--text-sub);
            text-transform: capitalize;
          }

          .article-style-five__title {
            color: var(--text-default-inverse);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            word-break: break-word;
          }

          .article-style-five__title:hover {
            text-decoration: underline;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardFive.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  category: PropTypes.string,
}

export default MaleDailyArticleCardFive
